import { render } from "./VideoPlayRate.vue?vue&type=template&id=7dee2478&scoped=true"
import script from "./VideoPlayRate.vue?vue&type=script&lang=ts"
export * from "./VideoPlayRate.vue?vue&type=script&lang=ts"

import "./VideoPlayRate.vue?vue&type=style&index=0&id=7dee2478&scoped=true&lang=less"
import "./VideoPlayRate.vue?vue&type=style&index=1&id=7dee2478&lang=less"
script.render = render
script.__scopeId = "data-v-7dee2478"

export default script